// French catalogue for PipelinePage. Keyed by the English text (src/shared/i18n.ts).
import { registerFr } from '../i18n/index.js';

registerFr({
  'Pipeline': 'Pipeline',
  'seven stages': 'sept étapes',
  'a stage change is an event, never an overwrite': 'un changement d’étape est un événement, jamais une réécriture',
  'a deal without a next step is a fault, not a style': 'une affaire sans prochaine étape est une faute, pas un style',
  'New deal': 'Nouvelle affaire',

  'Weighted': 'Pondéré',
  'stage probability × face value': 'probabilité d’étape × valeur nominale',
  'Face value': 'Valeur nominale',
  '{n} open deals': '{n} affaires ouvertes',
  'Stale deals': 'Affaires stagnantes',
  'past {d}d in stage': 'plus de {d}j dans l’étape',
  'past {d}d in stage · {refs}': 'plus de {d}j dans l’étape · {refs}',
  'Cycle · 12m': 'Cycle · 12m',
  'days median': 'jours médian',
  'lead to signature': 'du lead à la signature',
  'lead to signature · {n} deals': 'du lead à la signature · {n} affaires',
  'Win rate · 12m': 'Taux de succès · 12m',
  '{w} won · {l} lost · loss reasons recorded': '{w} gagnées · {l} perdues · raisons de perte enregistrées',
  'no won or lost deals in 12 months': 'aucune affaire gagnée ou perdue en 12 mois',

  'Open deals': 'Affaires ouvertes',
  'stage is position, left to right': 'l’étape est une position, de gauche à droite',
  'No deals in this stage.': 'Aucune affaire dans cette étape.',
  '{d}d': '{d}j',
  'next:': 'prochaine étape :',
  'no next step': 'aucune prochaine étape',
  'in Signet': 'dans Signet',
  'won on': 'gagnée le',
  'Move stage →': 'Changer d’étape →',
  'Hand over to Signet →': 'Transmettre à Signet →',
  'pending Signet': 'Signet en attente',
  '· handover failed': '· transfert échoué',

  'Lost · 90d': 'Perdues · 90j',
  'every loss carries a reason and a revisit date': 'chaque perte porte une raison et une date de relance',
  'No deal has been lost in the last 90 days.': 'Aucune affaire n’a été perdue au cours des 90 derniers jours.',
  'lost on': 'perdue le',
  'reason:': 'raison :',
  'not recorded': 'non enregistrée',
  'revisit': 'relance',
  'no revisit date set': 'aucune date de relance définie',
  'Create task': 'Créer une tâche',
  'Commitments are not built yet — the interactions agent owns that page.': 'Les engagements ne sont pas encore construits — cette page appartient à l’agent interactions.',

  'Stage events · latest': 'Événements d’étape · les plus récents',
  'append-only': 'ajout seul',
  'No stage has moved yet.': 'Aucune étape n’a encore bougé.',
  'opened at {stage}': 'ouverte à {stage}',
  '{d}d in {stage}': '{d}j en {stage}',

  'Could not load the pipeline': 'Impossible de charger le pipeline',

  'Deal': 'Affaire',
  'Loading…': 'Chargement…',
  'Signet': 'Signet',
  'Loss reason': 'Motif de perte',

  'Organisation': 'Organisation',
  'Type to search organisations…': 'Tapez pour rechercher des organisations…',
  'Change': 'Changer',
  'Title': 'Titre',
  'What is being sold': 'Ce qui est vendu',
  'Face value (CHF)': 'Valeur nominale (CHF)',
  'Probability %': 'Probabilité %',
  'Next step': 'Prochaine étape',
  'Next step due': 'Échéance',
  'Deal created.': 'Affaire créée.',
  'Cancel': 'Annuler',
  'Save': 'Enregistrer',
  'Close': 'Fermer',

  'Move stage': 'Changer d’étape',
  'From': 'De',
  'To stage': 'À',
  'Reason': 'Raison',
  'Why the deal was lost — this becomes the loss reason': 'Pourquoi l’affaire a été perdue — devient la raison de perte',
  'Why this move, in one line': 'Pourquoi ce changement, en une ligne',
  'Quote': 'Citation',
  'optional': 'optionnel',
  'A verbatim line from the mail or the call, if there is one': 'Une ligne verbatim du courriel ou de l’appel, s’il y en a une',
  'Revisit on': 'Relance le',
  'Move': 'Changer',
  '{ref} moved to {stage}.': '{ref} a été déplacée vers {stage}.',

  'Hand over to Signet': 'Transmettre à Signet',
  'Client': 'Client',
  'Contacts': 'Contacts',
  'No contact will be sent — the deal has no buying group and no primary person.': 'Aucun contact ne sera envoyé — l’affaire n’a ni groupe d’achat ni personne principale.',
  '(no name)': '(sans nom)',
  'sponsor': 'sponsor',
  'Engagement': 'Mandat',
  'kickoff': 'démarrage',
  'Hand over': 'Transmettre',
  'Sending…': 'Envoi…',
  '{ref} handed over to Signet as {code}.': '{ref} transmise à Signet sous le code {code}.',
  '{ref} written to the Signet outbox — pending until Signet is configured.': '{ref} écrite dans la boîte de sortie Signet — en attente jusqu’à la configuration de Signet.',
  'Signet refused the handover.': 'Signet a refusé la transmission.',

  'Lead': 'Lead',
  'Qualified': 'Qualifiée',
  'Scoping': 'Cadrage',
  'Proposal': 'Offre',
  'Negotiation': 'Négociation',
  'Contracting': 'Contractualisation',
  'Won': 'Gagnée',
  'Lost': 'Perdue',

  'Buying group': 'Groupe d’achat',
  'coverage': 'couverture',
  'No buying group mapped yet.': 'Aucun groupe d’achat recensé pour l’instant.',
  'Add member →': 'Ajouter un membre →',
  'Role': 'Rôle',
  'Stance': 'Position',
  'Person': 'Personne',
  'Type to search people…': 'Rechercher une personne…',
  'Sponsor': 'Sponsor',
  'Budget owner': 'Responsable budget',
  'IT owner': 'Responsable informatique',
  'User': 'Utilisateur·rice',
  'Procurement': 'Achats',
  'Data protection': 'Protection des données',
  'Other': 'Autre',
  'Unknown': 'Inconnue',
  'Champion': 'Sponsor interne',
  'Neutral': 'Neutre',
  'Blocker': 'Bloquant',
}, 'PipelinePage');
